export default { sha: 'd36e31a6129adb4c6c056650332893fca5eb56c4', buildNumber: 'undefined' }
